import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createApp } from "vue";

import { authSrc } from "@/core/authSrc";
import { initSentry } from "@/shared/lib/sentry";
import { setupStaleChunkReload } from "@/shared/lib/staleChunkReload";
import "@/app/styles/index.css";

import App from "./App.vue";
import globalStore from "./core/store/globalStore";
import router from "./router";

const bootstrap = async (): Promise<void> => {
	setupStaleChunkReload(router);

	const pinia = createPinia();
	pinia.use(piniaPluginPersistedstate);

	const app = createApp(App);
	app.directive("auth-src", authSrc);
	app.use(pinia);
	app.use(globalStore);
	app.use(router);
	app.use(VueQueryPlugin, {
		enableDevtoolsV6Plugin: import.meta.env.DEV,
	});

	await initSentry(app, router);

	app.mount("#app");
};

void bootstrap();
